import {
  Card,
  CardContent,
  Grid,
  Typography,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Autocomplete,
  TextField,
  Button,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ZoomOut from '@mui/icons-material/ZoomOut';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'src/utils/axios';
import { confirmAlert } from 'react-confirm-alert';
import AlertAndLoading from 'src/components/AlertAndLoading';
import { getReceiptInfoChat } from 'src/store/slices/informationChatSlice';
import {
  generalFollowActions,
  getDetail
} from 'src/store/slices/generalFollowSlice';
import { getUser } from 'src/utils/Common';
import { Description } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  divCenter: {
    textAlign: 'center'
  },
  div: {
    fontWeight: '600',
    fontSize: '10px',
    width: '100%',
    color: '#546e7a',
    marginBottom: '4px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  div2: {
    fontSize: '12px',
    width: '100%',
    color: '#263238',
    fontWeight: '600'
  },
  infoBox: {
    padding: '8px 6px',
    backgroundColor: '#fafafa',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '3px',
      backgroundColor: '#FF9800',
      opacity: 1
    }
  },
  warningBox: {
    padding: '8px',
    background: 'linear-gradient(135deg, #FFF8E1 0%, #FFECB3 100%)',
    borderRadius: '8px',
    border: '2px solid #FFB74D',
    boxShadow: '0 2px 8px rgba(255,152,0,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    minHeight: '32px',
    position: 'relative',
    animation: '$pulse 2s ease-in-out infinite'
  },
  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 2px 8px rgba(255,152,0,0.2)'
    },
    '50%': {
      boxShadow: '0 4px 16px rgba(255,152,0,0.35)'
    },
    '100%': {
      boxShadow: '0 2px 8px rgba(255,152,0,0.2)'
    }
  },
  warningText: {
    fontSize: '11px',
    fontWeight: '700',
    color: '#E65100',
    textAlign: 'center',
    lineHeight: '1.4'
  },
  warningIcon: {
    color: '#F57C00',
    fontSize: '18px',
    animation: '$bounce 1s ease-in-out infinite'
  },
  '@keyframes bounce': {
    '0%, 100%': {
      transform: 'translateY(0)'
    },
    '50%': {
      transform: 'translateY(-3px)'
    }
  },
  mainCard: {
    border: '1px solid #e0e0e0',
    borderRadius: '16px',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    backgroundColor: '#fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  cardHeader: {
    backgroundColor: '#f5f5f5',
    color: '#424242',
    padding: '10px 16px',
    cursor: 'move',
    borderBottom: '1px solid #e0e0e0',
    '& .MuiCardHeader-title': {
      fontSize: '12px',
      fontWeight: '700',
      letterSpacing: '0.5px'
    }
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  },
  spinning: {
    animation: '$spin 1s linear infinite'
  }
}));

function GeneralInfo() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const SessionUser = getUser();

  const invoiceData = useSelector(
    (state) => state.generalFollowSlice.invoiceDetail
  );
  const [openCustomerTypePopUp, setOpenCustomerTypePopUp] =
    React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [responseMessage, setresponseMessage] = React.useState('');
  const [uyari, setUyari] = React.useState(false);
  const [alertType, setAlertType] = React.useState({
    ErrorType: 'error',
    ErrorTitle: 'Uyarı'
  });
  const [selectedOption, setSelectedOption] = React.useState({
    id: invoiceData[0]?.Consumer.ConsumerType,
    description: invoiceData[0]?.Consumer?.ConsumerTypeDesc
  });
  const [customerTypeInfo, setCustomerTypeInfo] = React.useState('');
  const [refreshing, setRefreshing] = React.useState(false);
  const [hideVMEInvoice, setHideVMEInvoice] = React.useState(false);
  const [hideVMRetailerInvoice, setHideVMRetailerInvoice] =
    React.useState(false);
  const [hideVerificationMessage, setHideVerificationMessage] =
    React.useState(false);

  const options =
    invoiceData[0].Consumer.ConsumerType === 2
      ? [{ id: 1, description: 'Müşteri' }]
      : [{ id: 2, description: 'Tüzel - Şirket' }];

  function InfoAlert(ErrorDescription, ErrorType, ErrorTitle) {
    setresponseMessage(ErrorDescription);
    setAlertType({
      ErrorType: ErrorType,
      ErrorTitle: ErrorTitle
    });
    setUyari(true);
    return;
  }

  const handleTextChange = (event) => {
    setCustomerTypeInfo(event.target.value);
  };

  const getTypeColor = (ConsumerType) => {
    let typographyStyle = {};
    let icon = null;

    if (ConsumerType === 1) {
      typographyStyle = { color: 'red', fontSize: '12px', fontWeight: 'bold' };
      icon = (
        <IconButton style={{ fontSize: 3 }}>
          <ZoomOut
            fontSize="small"
            sx={{ color: 'green' }}
            onClick={() => {
              setOpenCustomerTypePopUp(true);
            }}
          />
        </IconButton>
      );
    } else if (ConsumerType === 2) {
      typographyStyle = { color: 'orange' };
      icon = (
        <IconButton style={{ fontSize: 3 }}>
          <ZoomOut
            fontSize="small"
            sx={{ color: 'green' }}
            onClick={() => {
              setOpenCustomerTypePopUp(true);
            }}
          />
        </IconButton>
      );
    } else if (ConsumerType === 3) {
      typographyStyle = { color: 'green' };
    }

    return (
      <div
        className={classes.div2}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Typography
          variant="body2"
          color="textSecondary"
          component="div"
          style={typographyStyle}
        >
          {invoiceData[0]?.Consumer?.ConsumerTypeDesc}
        </Typography>
        {icon}
      </div>
    );
  };
  const handleSaveClick = () => {
    if (selectedOption.id == null || selectedOption.id == undefined) {
      return;
    }
    if (customerTypeInfo.length < 15) {
      InfoAlert('Açıklamanız 15 karakterden uzun olmalı ...', 'error', 'Uyarı');
      return;
    }
    setOpenCustomerTypePopUp(false);
    const data = {
      ApplicationNumber: invoiceData[0]?.Exchange?.ApplyNo,
      ServiceNumber: invoiceData[0]?.Exchange?.Service,
      CustomerNumber: invoiceData[0]?.Consumer?.Id,
      UserId: invoiceData[0]?.UserID,
      NewTaxNumber: null,
      Type: 2,
      NewCustomerType: selectedOption.id,
      Desc: customerTypeInfo
    };
    const data2 = {
      SessionUser: SessionUser?.UserId || 0,
      UnitCode: invoiceData[0]?.Exchange?.Service,
      ApplicationNumber: invoiceData[0]?.Exchange?.ApplyNo
    };
    confirmAlert({
      message: 'Bu işlemi gerçekleştirmek istediğinizden emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            setLoading(true);
            axios
              .post('DiaUpdateCustomerTypeAndTaxNumber', data, {
                headers: { 'Content-Type': 'application/json' }
              })
              .then((response) => {
                if (response.data.ErrorCode === '0') {
                  InfoAlert(
                    'İşleminiz başarılıyla gerçekleşmiştir...',
                    'success',
                    'Başarılı'
                  );
                  setLoading(false);

                  var tempData = JSON.parse(JSON.stringify(invoiceData));
                  tempData[0].Consumer.ConsumerType = selectedOption.id;
                  tempData[0].Consumer.ConsumerTypeDesc =
                    selectedOption.description;
                  dispatch(generalFollowActions.updateNewData(tempData));

                  dispatch(
                    getReceiptInfoChat([
                      invoiceData[0]?.Exchange?.ApplyNo,
                      invoiceData[0]?.Exchange?.Service
                    ])
                  )
                    .then((response) => {})
                    .catch((err) => {
                      setLoading(false);
                      return;
                    });
                  setCustomerTypeInfo('');
                  return;
                } else {
                  setLoading(false);
                  return;
                }
              })
              .catch((err) => {
                setLoading(false);
                return;
              });
          }
        },
        {
          label: 'Hayır',
          onClick: () => {}
        }
      ]
    });
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleRefresh = () => {
    setRefreshing(true);
    const data = {
      SessionUser: SessionUser?.UserId || 0,
      UnitCode: invoiceData[0]?.Exchange?.Service,
      ApplicationNumber: invoiceData[0]?.Exchange?.ApplyNo
    };
    dispatch(getDetail(data))
      .then(() => {
        setTimeout(() => setRefreshing(false), 500);
      })
      .catch(() => {
        setRefreshing(false);
      });
  };

  return (
    <Card className={classes.mainCard}>
      <AlertAndLoading
        Message={responseMessage}
        open={uyari}
        AlertType={alertType}
        onClose={uyariKapat}
        loading={loading}
      />
      {invoiceData[0]?.VMEInvoice &&
      String(invoiceData[0]?.VMEInvoice).trim().length > 0 &&
      invoiceData[0]?.VMEInvoice != '0' &&
      (invoiceData[0].Consumer.ConsumerType == 1 ||
        invoiceData[0].Consumer.ConsumerType == 2) &&
      !hideVMEInvoice ? (
        <Grid
          item
          xs={12}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            padding: '4px 16px'
          }}
        >
          <Box className={classes.warningBox} sx={{ maxWidth: '90%' }}>
            <WarningAmberIcon className={classes.warningIcon} />
            <Typography
              className={classes.warningText}
              sx={{ paddingRight: '28px' }}
            >
              {invoiceData[0].VMEInvoice}
            </Typography>
            {/* <IconButton
              size="small"
              onClick={() => setHideVMEInvoice(true)}
              sx={{
                position: 'absolute',
                right: 2,
                top: 2,
                padding: '4px',
                color: '#E65100'
              }}
            >
              <CloseIcon sx={{ fontSize: '16px' }} />
            </IconButton> */}
          </Box>
        </Grid>
      ) : null}
      {invoiceData[0]?.VMRetailerInvoice &&
      String(invoiceData[0]?.VMRetailerInvoice).trim().length > 0 &&
      invoiceData[0]?.VMRetailerInvoice != '0' &&
      invoiceData[0].Consumer.ConsumerType == 3 &&
      !hideVMRetailerInvoice ? (
        <Grid
          item
          xs={12}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            padding: '4px 16px'
          }}
        >
          <Box className={classes.warningBox} sx={{ maxWidth: '90%' }}>
            <WarningAmberIcon className={classes.warningIcon} />
            <Typography
              className={classes.warningText}
              sx={{ paddingRight: '28px' }}
            >
              {invoiceData[0].VMRetailerInvoice}
            </Typography>
            {/* <IconButton
              size="small"
              onClick={() => setHideVMRetailerInvoice(true)}
              sx={{
                position: 'absolute',
                right: 2,
                top: 2,
                padding: '4px',
                color: '#E65100'
              }}
            >
              <CloseIcon sx={{ fontSize: '16px' }} />
            </IconButton> */}
          </Box>
        </Grid>
      ) : null}
      {invoiceData[0]?.ShowVerificationMessage &&
      String(invoiceData[0]?.ShowVerificationMessage).trim().length > 0 &&
      invoiceData[0]?.ShowVerificationMessage != '0' &&
      !hideVerificationMessage ? (
        <Grid
          item
          xs={12}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            padding: '4px 16px'
          }}
        >
          <Box className={classes.warningBox} sx={{ maxWidth: '90%' }}>
            <WarningAmberIcon className={classes.warningIcon} />
            <Typography
              className={classes.warningText}
              sx={{ paddingRight: '28px' }}
            >
              {invoiceData[0]?.ShowVerificationMessage}
            </Typography>
            {/* <IconButton
              size="small"
              onClick={() => setHideVerificationMessage(true)}
              sx={{
                position: 'absolute',
                right: 2,
                top: 2,
                padding: '4px',
                color: '#E65100'
              }}
            >
              <CloseIcon sx={{ fontSize: '16px' }} />
            </IconButton> */}
          </Box>
        </Grid>
      ) : null}
      <CardContent>
        <Grid container spacing={2} style={{ paddingTop: 5 }}>
          <Grid item xs={1.7}>
            <Box className={classes.infoBox}>
              <Typography
                variant="body2"
                className={classes.div}
                sx={{ textAlign: 'center' }}
              >
                {'Müşteri Tipi:'}
              </Typography>
              <Box
                sx={{
                  textAlign: 'center',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {getTypeColor(invoiceData[0]?.Consumer?.ConsumerType)}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={1.7}>
            <Box className={classes.infoBox}>
              <Typography
                variant="body2"
                className={classes.div}
                sx={{ textAlign: 'center' }}
              >
                {'Servis:'}
              </Typography>
              <Typography
                variant="body2"
                className={classes.div2}
                sx={{
                  textAlign: 'center',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {invoiceData[0]?.Service + '-' + invoiceData[0]?.ServiceName
                  ? invoiceData[0]?.Service + '-' + invoiceData[0]?.ServiceName
                  : '-'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={1.7}>
            <Box className={classes.infoBox}>
              <Typography
                variant="body2"
                className={classes.div}
                sx={{ textAlign: 'center' }}
              >
                {'Durum:'}
              </Typography>
              <Typography
                variant="body2"
                className={classes.div2}
                sx={{
                  textAlign: 'center',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {invoiceData[0]?.Exchange?.StatuDesc
                  ? invoiceData[0]?.Exchange?.StatuDesc
                  : '-'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={1.7}>
            <Box className={classes.infoBox}>
              <Typography
                variant="body2"
                className={classes.div}
                sx={{ textAlign: 'center' }}
              >
                {'Ara Durum:'}
              </Typography>
              <Typography
                variant="body2"
                className={classes.div2}
                sx={{
                  textAlign: 'center',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {invoiceData[0]?.Exchange?.IndermediateState
                  ? invoiceData[0]?.Exchange?.IndermediateState
                  : '-'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={1.7}>
            <Box className={classes.infoBox}>
              <Typography
                variant="body2"
                className={classes.div}
                sx={{ textAlign: 'center' }}
              >
                {'Çağrı T:'}
              </Typography>
              <Typography
                variant="body2"
                className={classes.div2}
                sx={{
                  textAlign: 'center',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {invoiceData[0]?.Apply?.ProcessDate
                  ? moment(invoiceData[0]?.Apply?.ProcessDate).format(
                      'DD.MM.YYYY'
                    )
                  : '-'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={1.7}>
            <Box className={classes.infoBox}>
              <Typography
                variant="body2"
                className={classes.div}
                sx={{ textAlign: 'center' }}
              >
                {'Değişim T:'}
              </Typography>
              <Typography
                variant="body2"
                className={classes.div2}
                sx={{
                  textAlign: 'center',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {invoiceData[0]?.Exchange?.ExchangeDate
                  ? moment(invoiceData[0]?.Exchange?.ExchangeDate).format(
                      'DD.MM.YYYY'
                    )
                  : '-'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={1.8}>
            <Box className={classes.infoBox}>
              <Typography
                variant="body2"
                className={classes.div}
                sx={{ textAlign: 'center' }}
              >
                {'Araç Yükleme T:'}
              </Typography>
              <Typography
                variant="body2"
                className={classes.div2}
                sx={{
                  textAlign: 'center',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {invoiceData[0]?.Exchange?.VehicleLoadDate
                  ? moment(invoiceData[0]?.Exchange?.VehicleLoadDate).format(
                      'DD.MM.YYYY HH:mm:ss'
                    )
                  : '-'}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2} style={{ paddingTop: 20 }}>
          <Grid item xs={2}>
            <Box className={classes.infoBox}>
              <Typography
                variant="body2"
                className={classes.div}
                sx={{ textAlign: 'center' }}
              >
                {'Tahmini Servise Teslim:'}
              </Typography>
              <Typography
                variant="body2"
                className={classes.div2}
                sx={{
                  textAlign: 'center',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {invoiceData[0]?.Exchange?.ServiceDeliveryDate
                  ? moment(
                      invoiceData[0]?.Exchange?.ServiceDeliveryDate
                    ).format('DD.MM.YYYY')
                  : '-'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box className={classes.infoBox}>
              <Typography
                variant="body2"
                className={classes.div}
                sx={{ textAlign: 'center' }}
              >
                {'Fatura T:'}
              </Typography>
              <Typography
                variant="body2"
                className={classes.div2}
                sx={{
                  textAlign: 'center',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {invoiceData[0]?.Exchange?.ReceiptDate
                  ? moment(invoiceData[0]?.Exchange?.ReceiptDate).format(
                      'DD.MM.YYYY'
                    )
                  : '-'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box className={classes.infoBox}>
              <Typography
                variant="body2"
                className={classes.div}
                sx={{ textAlign: 'center' }}
              >
                {'Gps No:'}
              </Typography>
              <Typography
                variant="body2"
                className={classes.div2}
                sx={{
                  textAlign: 'center',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {invoiceData[0]?.Exchange.GPSNO
                  ? invoiceData[0]?.Exchange.GPSNO
                  : '-'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box className={classes.infoBox}>
              <Typography
                variant="body2"
                className={classes.div}
                sx={{ textAlign: 'center' }}
              >
                {'Ud Fatura No:'}
              </Typography>
              <Typography
                variant="body2"
                className={classes.div2}
                sx={{
                  textAlign: 'center',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {invoiceData[0]?.Exchange?.UdOrderNo
                  ? invoiceData[0]?.Exchange?.UdOrderNo
                  : '-'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box className={classes.infoBox}>
              <Typography
                variant="body2"
                className={classes.div}
                sx={{ textAlign: 'center' }}
              >
                {'Sas:'}
              </Typography>
              <Typography
                variant="body2"
                className={classes.div2}
                sx={{
                  textAlign: 'center',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {invoiceData[0]?.Consumer.ChangeSasNo
                  ? invoiceData[0]?.Consumer.ChangeSasNo
                  : '-'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box className={classes.infoBox}>
              <Typography
                variant="body2"
                className={classes.div}
                sx={{ textAlign: 'center' }}
              >
                {'Sd:'}
              </Typography>
              <Typography
                variant="body2"
                className={classes.div2}
                sx={{
                  textAlign: 'center',
                  minHeight: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {invoiceData[0]?.Consumer.ChangeSdNo
                  ? invoiceData[0]?.Consumer.ChangeSdNo
                  : '-'}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>

      <Dialog
        open={openCustomerTypePopUp}
        onClose={() => setOpenCustomerTypePopUp(false)}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle
          sx={{
            width: '100%',
            color: 'red',
            fontSize: '16px',
            fontWeight: 'bold',
            textAlign: 'center'
          }}
        >
          Müşteri Tipi Değiştirme
        </DialogTitle>
        <DialogContent>
          <Grid item xs={12} md={12}>
            <Autocomplete
              options={options}
              getOptionLabel={(option) => option.description}
              value={selectedOption}
              onChange={(event, newValue) => setSelectedOption(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  size="small"
                  placeholder="Müşteri Tipi"
                />
              )}
            />
          </Grid>
          <br></br>
          <Grid item xs={12} md={12}>
            <TextField
              label="Açıklama"
              fullWidth
              maxRows={5}
              size="medium"
              multiline
              value={customerTypeInfo}
              onChange={handleTextChange}
            />
          </Grid>
          <br></br>
          <Grid item xs={12} md={12}>
            <Button
              size="small"
              fullWidth
              onClick={() => {
                handleSaveClick();
              }}
              sx={{ color: '#FF9800', backgroundColor: '#424242' }}
            >
              {'Kaydet'}
            </Button>
          </Grid>
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={() => {
              setOpenCustomerTypePopUp(false);
            }}
            aria-label="close"
            component="span"
            variant="contained"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
    </Card>
  );
}

export default GeneralInfo;
